import { render, staticRenderFns } from "./view-asset-history.vue?vue&type=template&id=0b7c0e86&scoped=true&class=abstretch&"
import script from "./view-asset-history.vue?vue&type=script&lang=ts&"
export * from "./view-asset-history.vue?vue&type=script&lang=ts&"
import style0 from "./view-asset-history.vue?vue&type=style&index=0&id=0b7c0e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c0e86",
  null
  
)

export default component.exports